import {
  GroupBase as DefaultGroupBase,
  OptionProps,
  components,
} from 'react-select';
import { Checkbox } from 'src/components/atoms/Checkbox';
import { MultiSelectOptionContainer } from '../DropdownSelect.styles';

export type DefaultOption = {
  pluralLabel?: string | number;
  label: string | number;
  value: string | number | boolean;
  tooltip?: string;
};

export const DropdownOptions = <
  Option extends DefaultOption = DefaultOption,
  GroupBase extends DefaultGroupBase<Option> = DefaultGroupBase<Option>,
>({
  ...props
}: OptionProps<Option, boolean, GroupBase>) => {
  const { isMulti } = props.selectProps;

  const tooltip = props.data.tooltip;

  return isMulti ? (
    <components.Option {...props}>
      <MultiSelectOptionContainer
        data-testid={`${props.label}-select`}
        title={tooltip}
      >
        <Checkbox
          checked={props.isSelected}
          onChange={() => null}
          variant="default"
          data-testid={`multi-select-option-${props.label}`}
        />
        <label>{props.label}</label>
      </MultiSelectOptionContainer>
    </components.Option>
  ) : (
    <div data-testid={`${props.label}-select`} title={tooltip}>
      <components.Option {...props} />
    </div>
  );
};
